'use strict';

/* =========================================================================
   BASIS — Statut d'ouverture live (propagé à tous les [data-status])
   Port basis-redesign/assets/js/script.js → initStatus().
   Horaires Basis hardcodés (cf basis-redesign brief) :
     - Lun–Jeu : 11h30–15h, 18h30–23h
     - Ven–Dim : 11h30–minuit (continu)
   Mise à jour : toutes les 60s.
   ========================================================================= */

function initBasisStatus() {
  const statusEls = document.querySelectorAll('[data-status]');
  if (statusEls.length === 0) return;

  function updateStatus() {
    const now = new Date();

    // Heure de Paris (HH:MM)
    const parisTimeStr = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(now);
    const [hours, minutes] = parisTimeStr.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes;

    // Jour de la semaine (Paris)
    const dayOfWeek = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris',
      weekday: 'long',
    }).format(now).toLowerCase();

    const isWeekend = ['friday', 'saturday', 'sunday'].includes(dayOfWeek);
    let isOpen = false;
    let label;

    if (isWeekend) {
      if (totalMinutes >= 690 && totalMinutes < 1440) {
        isOpen = true;
        label = "Ouvert jusqu'à minuit";
      } else if (totalMinutes < 690) {
        label = 'Ouvre à 11h30';
      } else {
        label = 'Fermé';
      }
    } else {
      if (totalMinutes >= 690 && totalMinutes < 900) {
        isOpen = true;
        label = "Ouvert jusqu'à 15h";
      } else if (totalMinutes >= 1110 && totalMinutes < 1380) {
        isOpen = true;
        label = "Ouvert jusqu'à 23h";
      } else if (totalMinutes >= 900 && totalMinutes < 1110) {
        label = 'Ouvre à 18h30';
      } else if (totalMinutes < 690) {
        label = 'Ouvre à 11h30';
      } else {
        label = 'Fermé';
      }
    }

    statusEls.forEach((el) => {
      el.textContent = label;
      el.setAttribute('data-status', isOpen ? 'open' : 'closed');
    });
  }

  updateStatus();
  setInterval(updateStatus, 60000);
}

document.addEventListener('DOMContentLoaded', initBasisStatus);
